export default __webpack_public_path__ + "4d20b0ed6f5cd3210936085e59eb19a3.png";